import cssVars from 'css-vars-ponyfill'
import lightTheme from './lightTheme'
import darkTheme from './darkTheme'
import store from '@/store'
import { getLocalStorage } from '@/utils/locatonStorge'
export const LIGHT_MODE = 1 // 正常模式
export const DARK_MODE = 2 // 深夜模式
export const FLOW_SYSTEM = 3 // 跟随系统
export const SKIN_MODE = 'SKIN_MODE' // 暗黑模式
export const darkList = [LIGHT_MODE, DARK_MODE]
export function setTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme ? 'dark' : 'light')
  cssVars({
    watch: true, // 当添加，删除或修改其<link>或<style>元素的禁用或href属性时，ponyfill将自行调用
    variables: theme ? darkTheme : lightTheme, // variables 自定义属性名/值对的集合
    onlyLegacy: true // false  默认将css变量编译为浏览器识别的css样式  true 当浏览器不支持css变量的时候将css变量编译为识别的css
    // exclude: ['#login-layout-container']
  })
}
export function addDarkEventListener() {
  const storageMode = Number(getLocalStorage(SKIN_MODE))
  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
      if (darkList.includes(storageMode)) {
        return false
      }
      initTheme(event.matches)
    })
  }
}
export function initTheme(isAddListener = true) {
  // 是否暗黑模式
  let isDarkMode = false
  const storageMode = Number(getLocalStorage(SKIN_MODE))
  if (darkList.includes(storageMode)) {
    isDarkMode = +storageMode === 2
  } else {
    // 暗黑模式
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)')?.matches) {
      isDarkMode = true
    } else {
      isDarkMode = false
    }
  }
  store.commit('DarkMode/SET_DARK_MODE', isDarkMode)
  store.commit('DarkMode/SET_THEME_TEXT', storageMode)
  setTheme(isDarkMode)
  if (isAddListener) {
    addDarkEventListener()
  }
}
initTheme()
